export default __webpack_public_path__ + "static/media/gif-file.69b68646.svg";